import Vue from 'vue'
import VueHead from 'vue-head'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import Nl2br from 'vue-nl2br';
import VueI18n from 'vue-i18n'
import VueScroller from 'vue-scroller'
import VueSnap from 'vue-snap';
Vue.config.productionTip = false
Vue.use(VueScroller)
Vue.use(VueSnap);
// VueHead利用
Vue.use(VueHead)

// 改行コードを<br>に変換するもの
Vue.component('nl2br', Nl2br)

// 多言語対応
Vue.use(VueI18n)
import { localization } from '@/lib/lang/index.js'
const i18n = new VueI18n({
  locale: 'jp', // デフォルト言語設定
  fallbackLocale: 'jp', // 選択中の言語に対応する文字列が存在しない場合はこの言語の文字列を使用する
  messages: localization
})

new Vue({
  vuetify,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')
